<template>
  <div class="eoi">
        <slot name="csrf"></slot>

        <!-- 1. Pesquisa -->
        <form class="mb-3" @submit.prevent="getLiberacaoInscricoesWebERP()" novalidate>
            <fieldset class="ec-form-secao mb-0">
                <legend><b-icon icon="funnel"></b-icon> Turmas liberadas para inscrição web</legend>
                <ol class="eoi-passos">
                    <li><b>Busque</b> as turmas liberadas para inscrição no ERP.</li>
                    <li><b>Confira</b> período, modalidade e valor de cada turma.</li>
                    <li><b>Exporte</b> a turma para o CRM como oferta.</li>
                </ol>
                <div class="d-flex flex-wrap justify-content-end" style="gap:.5rem;">
                    <a :href="'/Access/Unity/Unitie/'+unitie.id+'/oferta_inscricao_web'" class="btn btn-outline-primary"><b-icon icon="list-ul"></b-icon> Ver exportações</a>
                    <button type="submit" class="btn btn-primary" :disabled="buscando">
                        <b-icon :icon="buscou ? 'arrow-clockwise' : 'search'"></b-icon> {{ buscou ? 'Atualizar lista' : 'Buscar turmas' }}
                    </button>
                </div>
                <p class="form-text text-muted mb-0 mt-2">
                    Esta tela apenas consulta o ERP. Se uma turma não aparecer, procure o responsável pelo ERP na instituição.
                </p>
            </fieldset>
        </form>

        <!-- retorno do ERP sem turmas -->
        <div v-if="msgErro" class="alert alert-warning d-flex align-items-start" role="alert" style="gap:.6rem;">
            <b-icon icon="exclamation-triangle-fill" class="mt-1"></b-icon>
            <div>
                <strong>Nenhuma liberação de inscrição encontrada para esta unidade.</strong><br/>
                <small>Resposta do ERP: {{ msgErro }}</small>
            </div>
        </div>

        <!-- estado inicial / lista vazia -->
        <div v-else-if="cursos.length==0" class="ec-card eoi-vazio">
            <b-icon :icon="buscou ? 'inbox' : 'search'" font-scale="2"></b-icon>
            <p v-if="!buscou">Clique em <b>Buscar turmas</b> para carregar as turmas liberadas no ERP.</p>
            <p v-else>O ERP não retornou turmas liberadas para inscrição nesta unidade.</p>
        </div>

        <template v-else>
            <!-- 2. Resumo e filtros da lista -->
            <div class="eoi-barra">
                <div class="eoi-resumo">
                    <span><b>{{ cursos.length }}</b> curso(s)</span>
                    <span><b>{{ resumo.turmas }}</b> turma(s)</span>
                    <span class="ec-status ec-status--sucesso" v-if="resumo.exportadas>0">{{ resumo.exportadas }} exportada(s)</span>
                    <span class="ec-status ec-status--erro" v-if="resumo.falhas>0">{{ resumo.falhas }} com falha</span>
                    <span class="ec-status ec-status--aguardando" v-if="resumo.semModalidade>0" title="Turmas sem modalidade não podem ser exportadas">{{ resumo.semModalidade }} sem modalidade</span>
                </div>
                <div class="eoi-filtros">
                    <div class="eoi-busca">
                        <b-icon icon="search"></b-icon>
                        <input type="search" class="form-control form-control-sm" v-model="busca" placeholder="Buscar curso ou turma" aria-label="Buscar curso ou turma">
                    </div>
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="eoiSomenteAbertas" v-model="somenteAbertas">
                        <label class="custom-control-label" for="eoiSomenteAbertas">Só inscrições abertas</label>
                    </div>
                </div>
            </div>

            <p v-if="cursosVisiveis.length==0" class="ec-card eoi-vazio">
                Nenhuma turma corresponde aos filtros.
            </p>

            <!-- 3. Cursos e turmas -->
            <details class="ec-card eoi-curso" v-for="curso in cursosVisiveis" :key="curso.chave" :open="cursosVisiveis.length==1 || !!busca || somenteAbertas">
                <summary class="ec-card__cabecalho">
                    <span class="ec-card__icone"><i class="fa-solid fa-graduation-cap"></i></span>
                    <div class="ec-card__textos">
                        <h3 class="ec-card__titulo">{{ (curso.original.descricaoCurso!='' && curso.original.idCurso>0 ? curso.original.descricaoCurso : 'INFORMAÇÃO') }}</h3>
                        <p class="ec-card__subtitulo eoi-meta">
                            <span v-if="curso.original.idCurso>0">Cód. {{ curso.original.idCurso }}</span>
                            <span v-if="curso.original.descricaoNivelEnsino">{{ curso.original.descricaoNivelEnsino }}</span>
                            <span v-if="curso.original.descricaoOrigemMatricula">{{ curso.original.descricaoOrigemMatricula }}</span>
                        </p>
                    </div>
                    <span class="ec-card__extra eoi-curso__extra">
                        <span class="ec-status" :class="exportadasCurso(curso)==curso.turmas.length ? 'ec-status--sucesso' : 'ec-status--neutro'">
                            {{ exportadasCurso(curso) }}/{{ curso.turmas.length }} exportada(s)
                        </span>
                    </span>
                </summary>
                <div class="ec-card__corpo ec-card__corpo--flush">
                    <div class="eoi-curso__acoes" v-if="exportaveisCurso(curso).length>1">
                        <button type="button" class="btn btn-sm btn-outline-primary" :disabled="!!curso.lote || exportando>0" @click="confirmarExportacaoCurso(curso)">
                            <b-icon icon="cloud-upload"></b-icon>
                            {{ curso.lote ? 'Exportando ' + curso.lote.feitas + '/' + curso.lote.total + '...' : 'Exportar todas as turmas (' + exportaveisCurso(curso).length + ')' }}
                        </button>
                    </div>
                    <ul class="eoi-lista">
                        <li v-for="item in curso.turmas" :key="item.chave" class="eoi-turma">
                            <div class="eoi-turma__linha">
                                <div class="eoi-turma__info">
                                    <span class="eoi-turma__nome">{{ item.turma.descricaoofertainscricao || item.turma.descricaoTurma }}</span>
                                    <span class="eoi-meta eoi-turma__meta">
                                        <span v-if="item.turma.descricaoTurma">Turma ERP: <b>{{ String(item.turma.descricaoTurma).trim() }}</b></span>
                                        <span v-if="item.turma.descricaoCiclo">{{ item.turma.descricaoCiclo }}</span>
                                        <span v-if="item.turma.anoInicio">Início {{ item.turma.anoInicio }}</span>
                                        <span><b-icon icon="calendar3"></b-icon> Inscrições: {{ formatarData(item.turma.dataInicioInscricao) }} a {{ formatarData(item.turma.dataTerminoInscricao) }}</span>
                                        <span v-if="vagas(item.turma)">{{ vagas(item.turma) }}</span>
                                    </span>
                                </div>
                                <div class="eoi-turma__extra">
                                    <span class="ec-status" :class="'ec-status--'+situacaoInscricoes(item.turma).variante">{{ situacaoInscricoes(item.turma).texto }}</span>
                                    <span v-if="item.turma.descricaoModalidade" class="ec-card__etiqueta">{{ item.turma.descricaoModalidade }}</span>
                                    <span v-else class="ec-status ec-status--aguardando" title="Configure a modalidade da turma no ERP para poder exportá-la">Sem modalidade</span>
                                    <button v-if="planoPagamento(item.turma)" type="button" class="btn btn-link btn-sm p-0 eoi-valor" title="Ver plano de pagamento" @click="verPlanoPagamento(item.turma)">
                                        {{ valorOferta(item.turma) }} <b-icon icon="info-circle"></b-icon>
                                    </button>
                                    <span v-else class="eoi-valor eoi-valor--isento">Isento</span>
                                    <button type="button" class="btn btn-sm" :class="item.situacao=='sucesso' ? 'btn-outline-primary' : 'btn-primary'"
                                        :disabled="!podeExportar(item.turma) || item.situacao=='exportando' || visualizar"
                                        :title="podeExportar(item.turma) ? 'Enviar esta turma ao CRM como oferta' : 'Turma sem modalidade: não pode ser exportada'"
                                        @click="exportarTurma(item, curso)">
                                        <b-spinner v-if="item.situacao=='exportando'" small></b-spinner>
                                        <b-icon v-else icon="cloud-upload"></b-icon>
                                        {{ item.situacao=='exportando' ? 'Exportando...' : (item.situacao=='sucesso' ? 'Exportar de novo' : 'Exportar CRM') }}
                                    </button>
                                </div>
                            </div>
                            <div v-if="item.situacao=='sucesso' || item.situacao=='erro'" class="eoi-turma__retorno" :class="'eoi-turma__retorno--'+item.situacao" role="status">
                                <template v-if="item.situacao=='sucesso'">
                                    <b-icon icon="check-circle-fill"></b-icon> Exportada para o CRM às {{ item.horario }} · oferta {{ item.codOferta }}
                                </template>
                                <template v-else>
                                    <b-icon icon="x-circle-fill"></b-icon> Falhou: {{ item.mensagem }}
                                </template>
                            </div>
                        </li>
                    </ul>
                </div>
            </details>
        </template>

        <b-modal id="eoiPlanoPagamento" title="Plano de pagamento" ok-only ok-title="Fechar" ok-variant="outline-primary" centered size="lg" @hidden="plano_pagamento_visualizar=null">
            <template v-if="plano_pagamento_visualizar">
                <dl class="eoi-dados">
                    <div>
                        <dt>Descrição</dt>
                        <dd>{{ plano_pagamento_visualizar.descricaoPlanoPagamento || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Parcelas</dt>
                        <dd>{{ (plano_pagamento_visualizar.parcelas || []).length }}</dd>
                    </div>
                    <div>
                        <dt>Total</dt>
                        <dd>{{ $root.numberToReal(totalPlano(plano_pagamento_visualizar)) }}</dd>
                    </div>
                </dl>
                <div class="ec-listagem">
                    <div class="table-responsive ec-listagem__rolagem">
                        <table class="table table-sm table-hover ec-tabela eoi-parcelas mb-0">
                            <thead class="ec-thead">
                                <tr>
                                    <th class="text-center">Nº</th>
                                    <th class="text-left">Tipo de parcela</th>
                                    <th class="text-left">Evento</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="parcela,i in (plano_pagamento_visualizar.parcelas || [])" :key="i">
                                    <td class="text-center" data-label="Nº"><span class="d-md-none">Parcela </span>{{ parcela.numeroParcela }}</td>
                                    <td class="text-left" data-label="Tipo de parcela">
                                        <template v-if="parcela.descricaoTipoParcela">{{ parcela.descricaoTipoParcela }}</template>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td class="text-left" data-label="Evento">
                                        <template v-if="evento(parcela) && evento(parcela).descricaoEvento">{{ evento(parcela).descricaoEvento }}</template>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td class="text-right" data-label="Valor">
                                        <template v-if="evento(parcela)">{{ $root.numberToReal(parseFloat(evento(parcela).valor)) }}</template>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                </tr>
                                <tr v-if="(plano_pagamento_visualizar.parcelas || []).length==0">
                                    <td colspan="4" class="ec-tabela__estado">
                                        <b-icon icon="inbox" font-scale="2"></b-icon>
                                        <p>Este plano de pagamento não tem parcelas cadastradas no ERP.</p>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="(plano_pagamento_visualizar.parcelas || []).length>1">
                                <tr>
                                    <td colspan="3" class="text-right">Total do plano</td>
                                    <td class="text-right">{{ $root.numberToReal(totalPlano(plano_pagamento_visualizar)) }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </template>
        </b-modal>

        <loading id="carregandoInscricoesWeb" titulo="Buscando turmas liberadas no ERP..." :sem-padding="true" gif-carregando="/imagens/carregando.gif" @cancelaRequisicao="cancelarRequisicao()"></loading>
  </div>
</template>

<script>
export default {
    // filtroEditado é mantido por compatibilidade com a view
    props:['usuarioLogado','unitie','urlRedirect','filtroEditado','visualizar'],
    data(){
        return{
            cursos:[],
            buscando:false,
            buscou:false,
            msgErro:null,
            cancelTokenSource:null,
            busca:'',
            somenteAbertas:false,
            exportando:0,
            plano_pagamento_visualizar:null,
        }
    },
    computed:{
        resumo(){
            const itens = this.cursos.reduce((lista, curso) => lista.concat(curso.turmas), [])
            return {
                turmas: itens.length,
                exportadas: itens.filter(i => i.situacao=='sucesso').length,
                falhas: itens.filter(i => i.situacao=='erro').length,
                semModalidade: itens.filter(i => !this.podeExportar(i.turma)).length,
            }
        },
        cursosVisiveis(){
            const termo = this.normalizar(this.busca)
            if(!termo && !this.somenteAbertas) return this.cursos
            return this.cursos.map(curso => {
                const cursoCombina = !termo || this.normalizar(curso.original.descricaoCurso).includes(termo)
                const turmas = curso.turmas.filter(item => {
                    if(this.somenteAbertas && this.situacaoInscricoes(item.turma).variante!='sucesso') return false
                    if(cursoCombina) return true
                    const t = item.turma
                    return this.normalizar([t.descricaoofertainscricao, t.descricaoTurma, t.descricaoCiclo, t.descricaoModalidade].join(' ')).includes(termo)
                })
                return Object.assign({}, curso, { turmas })
            }).filter(curso => curso.turmas.length>0)
        },
    },
    methods:{
        normalizar(texto){
            return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
        },
        // datas "aaaa-mm-dd" são lidas como data local (new Date() as trataria como UTC e voltaria um dia)
        paraData(valor){
            if(!valor) return null
            if(valor instanceof Date) return valor
            const soData = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(valor))
            const data = soData ? new Date(soData[1], soData[2]-1, soData[3]) : new Date(valor)
            return isNaN(data.getTime()) || data.getFullYear() < 1971 ? null : data
        },
        formatarData(valor){
            const data = this.paraData(valor)
            return data ? data.toLocaleDateString('pt-BR') : '—'
        },
        situacaoInscricoes(turma){
            const inicio = this.paraData(turma.dataInicioInscricao)
            const termino = this.paraData(turma.dataTerminoInscricao)
            if(!inicio || !termino) return { texto:'Sem período', variante:'neutro' }
            const hoje = new Date()
            hoje.setHours(0,0,0,0)
            const fim = new Date(termino)
            fim.setHours(23,59,59,999)
            if(hoje < inicio) return { texto:'Em breve', variante:'pendente' }
            if(hoje > fim) return { texto:'Encerradas', variante:'neutro' }
            return { texto:'Abertas', variante:'sucesso' }
        },
        vagas(turma){
            const minimo = turma.tamanhoturmaminimo, maximo = turma.tamanhoturmaximo
            const temMin = minimo !== null && minimo !== undefined && minimo !== '' && minimo > 0
            const temMax = maximo !== null && maximo !== undefined && maximo !== '' && maximo > 0
            if(temMin && temMax) return 'Vagas: ' + minimo + ' a ' + maximo
            if(temMax) return 'Até ' + maximo + ' vagas'
            if(temMin) return 'Mínimo ' + minimo + ' alunos'
            return null
        },
        planoPagamento(turma){
            return (turma.planosPagamento || []).length > 0 ? turma.planosPagamento[0] : null
        },
        evento(parcela){
            return (parcela.eventos || []).length > 0 ? parcela.eventos[0] : null
        },
        // valor da 1ª parcela do 1º plano: é o que segue para o CRM
        valorPrimeiraParcela(turma){
            const plano = this.planoPagamento(turma)
            const parcela = plano && (plano.parcelas || [])[0]
            const evento = parcela && this.evento(parcela)
            const valor = evento ? parseFloat(evento.valor) : NaN
            return isNaN(valor) ? 0 : valor
        },
        valorOferta(turma){
            return this.$root.numberToReal(this.valorPrimeiraParcela(turma))
        },
        totalPlano(plano){
            return (plano.parcelas || []).reduce((soma, parcela) => {
                const evento = this.evento(parcela)
                const valor = evento ? parseFloat(evento.valor) : NaN
                return soma + (isNaN(valor) ? 0 : valor)
            }, 0)
        },
        podeExportar(turma){
            return !!turma.descricaoModalidade && !!turma.modalidade
        },
        exportaveisCurso(curso){
            return curso.turmas.filter(item => this.podeExportar(item.turma))
        },
        exportadasCurso(curso){
            return curso.turmas.filter(item => item.situacao=='sucesso').length
        },
        avisar(mensagem,variante,titulo){
            this.$bvToast.toast(mensagem, {
                title: titulo,
                variant: variante,
                solid: true,
                toaster: 'b-toaster-top-right',
                autoHideDelay: variante=='danger' ? 8000 : 4000,
            })
        },
        mensagemErro(erros){
            if(!erros) return 'Erro não informado pelo CRM.'
            if(typeof erros === 'string') return erros
            // o CRM devolve objeto/array de mensagens; achata em uma linha legível
            const lista = []
            const coletar = v => {
                if(v === null || v === undefined) return
                if(typeof v === 'object') Object.values(v).forEach(coletar)
                else lista.push(String(v))
            }
            coletar(erros)
            return lista.length ? lista.join(' · ') : JSON.stringify(erros)
        },
        cancelarRequisicao(){
            if(this.cancelTokenSource){
                this.cancelTokenSource.cancel('Pesquisa de turmas do ERP cancelada')
            }
        },
        getLiberacaoInscricoesWebERP(){
            this.buscando = true
            this.cancelTokenSource = axios.CancelToken.source()
            $('#carregandoInscricoesWeb').modal('show')

            const filtroPesquisaInscricao = {
                ano:null,
                semestre:null,
                idEmpresa: this.unitie.companies.codigoempresa,
                idUnidade: this.unitie.codigounidade,
                idUnidadePk:null,
                dataInicio:null,
                dataTermino:null,
                idCurso:null,
                curso:null,
                oferta_processo_seletivo:0,
                oferta_Inscricao_web:1,
                inscricao_web_aluno:0,
                importar_parcela:0,
                download_contrato:0,
                somenteativo:1,
            }
            const formData = new FormData()
            formData.append('filtroPesquisaInscricao', JSON.stringify(filtroPesquisaInscricao))

            axios.post('/api/v1/Erp/Inscricoes/' + this.unitie.id, formData, { cancelToken: this.cancelTokenSource.token })
                .then(response => {
                    this.buscou = true
                    if(response.data.InscricoesErp){
                        this.cursos = response.data.InscricoesErp.map((curso, i) => ({
                            chave: (curso.idLiberacaoInscricaoCurso || '') + '-' + (curso.idCurso || '') + '-' + i,
                            original: curso,
                            lote: null,
                            turmas: (curso.turmas || []).map((turma, j) => ({
                                chave: (turma.idLiberacaoInscricaoTurma || turma.idTurma || '') + '-' + j,
                                turma,
                                situacao: null,
                                mensagem: null,
                                horario: null,
                                codOferta: null,
                            })),
                        }))
                        this.msgErro = null
                        const turmas = this.cursos.reduce((n, c) => n + c.turmas.length, 0)
                        this.avisar(turmas + ' turma(s) em ' + this.cursos.length + ' curso(s).', 'success', 'Lista atualizada')
                    }else{
                        this.cursos = []
                        this.msgErro = response.data.message ? this.mensagemErro(response.data.message) : 'Resposta inesperada do ERP.'
                    }
                })
                .catch(erro => {
                    if(axios.isCancel(erro)){
                        this.avisar('A busca foi cancelada.', 'warning', 'Busca cancelada')
                        return
                    }
                    console.log(erro)
                    this.cursos = []
                    this.buscou = true
                    this.avisar('Erro ao consultar o ERP. Tente novamente.', 'danger', 'Erro na busca')
                })
                .finally(() => {
                    this.buscando = false
                    $('#carregandoInscricoesWeb').modal('hide')
                })
        },
        verPlanoPagamento(turma){
            this.plano_pagamento_visualizar = this.planoPagamento(turma)
            this.$bvModal.show('eoiPlanoPagamento')
        },
        montarOferta(turma, curso){
            const codigo = curso.idLiberacaoInscricaoCurso+'-'+curso.idCurso+'-'+turma.idCiclo+'-'+turma.idTurma
            const local = this.unitie.companies.codigoempresa + '-' + this.unitie.codigounidade
            return {
                idLiberacaoInscricaoCurso: curso.idLiberacaoInscricaoCurso,
                idLiberacaoInscricaoTurma: turma.idLiberacaoInscricaoTurma,
                ano: turma.anoInicio,
                semestre: curso.semestre,
                idNivelEnsino: curso.idNivelEnsino,
                descricaoNivelEnsino: curso.descricaoNivelEnsino,
                idEstruturaAcademica: turma.idModalidade,
                descricaoEstruturaAcademica: turma.descricaoModalidade,
                idOrigemMatricula: curso.idOrigemMatricula,
                descricaoOrigemMatricula: curso.descricaoOrigemMatricula,
                publico: curso.publico,
                codCurso: curso.idCurso,
                codOferta: codigo,
                codigo: codigo,
                nomeCurso: curso.descricaoCurso,
                descricaoCurso: curso.descricaoCurso,
                nome: turma.descricaoofertainscricao,
                complemento: turma.descricaocomplemento,
                codUnidade: local,
                inicioInscricao: turma.dataInicioInscricao,
                terminoInscricao: turma.dataTerminoInscricao,
                inicioMatricula: turma.dataInicio,
                terminoMatricula: turma.dataTermino,
                inicioCurso: turma.dataInicio,
                terminoCurso: turma.dataTermino,
                codNivelEnsino: curso.idNivelEnsino,
                modalidade: turma.modalidade.idmodalidadeexportacao,
                codLocalOferta: local,
                origem: this.unitie.origem,
                vagasMinimo: turma.tamanhoturmaminimo,
                vagasMaximo: turma.tamanhoturmaximo,
                valor: this.valorPrimeiraParcela(turma),
                plano_pagamento: this.planoPagamento(turma),
            }
        },
        // devolve null em caso de sucesso ou a mensagem de erro
        lerRetornoExportacao(dados){
            if(Array.isArray(dados) && dados.length>0 && dados[0].error){
                let erro = dados[0].message
                try{
                    const json = typeof erro === 'string' ? JSON.parse(erro) : erro
                    erro = json && json.errors ? json.errors : json
                }catch(e){ /* mensagem em texto */ }
                return this.mensagemErro(erro)
            }
            if(dados && dados.resposta){
                let resposta = dados.resposta
                try{
                    resposta = typeof resposta === 'string' ? JSON.parse(resposta) : resposta
                }catch(e){
                    return null
                }
                if(resposta && resposta.success === false) return this.mensagemErro(resposta.errors)
            }
            return null
        },
        // exporta uma turma; com silencioso=true não mostra toast (usado na exportação em lote)
        exportarTurma(item, curso, silencioso){
            if(!this.podeExportar(item.turma)) return Promise.resolve(false)
            const oferta = this.montarOferta(item.turma, curso.original)
            item.situacao = 'exportando'
            item.mensagem = null
            this.exportando++

            const formData = new FormData()
            formData.append('dadosOferta', JSON.stringify(oferta))

            return axios.post('/api/v1/Crm/cadastroOferta/' + this.unitie.id, formData)
                .then(response => {
                    const erro = this.lerRetornoExportacao(response.data)
                    if(erro){
                        item.situacao = 'erro'
                        item.mensagem = erro
                        if(!silencioso) this.avisar('O CRM recusou a turma ' + oferta.nome + '.', 'danger', 'Erro na exportação')
                        return false
                    }
                    item.situacao = 'sucesso'
                    item.codOferta = oferta.codOferta
                    item.horario = new Date().toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' })
                    if(!silencioso) this.avisar('Turma ' + oferta.nome + ' exportada para o CRM.', 'success', 'Exportação concluída')
                    return true
                })
                .catch(erro => {
                    console.log(erro)
                    const detalhe = erro.response && erro.response.data ? erro.response.data.message : null
                    item.situacao = 'erro'
                    item.mensagem = detalhe ? String(detalhe) : 'Erro de comunicação. Verifique a conexão e tente novamente.'
                    if(!silencioso) this.avisar('Erro ao exportar a turma. Tente novamente.', 'danger', 'Erro na exportação')
                    return false
                })
                .finally(() => {
                    this.exportando--
                })
        },
        confirmarExportacaoCurso(curso){
            // usa o curso completo (sem os filtros da tela)
            const completo = this.cursos.find(c => c.chave == curso.chave) || curso
            const itens = this.exportaveisCurso(completo)
            const mensagem = 'Exportar ' + itens.length + ' turma(s) de ' + completo.original.descricaoCurso + ' para o CRM? As ofertas já existentes no CRM serão atualizadas.'
            this.$bvModal.msgBoxConfirm(mensagem, {
                title: 'Exportar para o CRM',
                okTitle: 'Exportar',
                cancelTitle: 'Cancelar',
                okVariant: 'primary',
                cancelVariant: 'outline-primary',
                centered: true,
            }).then(confirmou => {
                if(confirmou) this.exportarCurso(completo, itens)
            })
        },
        // uma turma por vez, para não sobrecarregar o CRM
        async exportarCurso(curso, itens){
            curso.lote = { feitas:0, total:itens.length }
            let sucessos = 0
            for(const item of itens){
                if(await this.exportarTurma(item, curso, true)) sucessos++
                curso.lote.feitas++
            }
            curso.lote = null
            if(sucessos == itens.length){
                this.avisar(sucessos + ' turma(s) exportada(s) para o CRM.', 'success', 'Exportação concluída')
            }else{
                this.avisar((itens.length-sucessos) + ' de ' + itens.length + ' turma(s) não foram exportadas. Veja o motivo em cada turma.', 'warning', 'Exportação com pendências')
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.eoi { text-align: left; }

.eoi-passos {
    display: flex;
    flex-wrap: wrap;
    gap: .35rem 1.5rem;
    margin: 0 0 1rem;
    padding: 0;
    list-style: none;
    counter-reset: passo;
    font-size: .85rem;
    color: $ec-texto-suave;

    li {
        counter-increment: passo;
        display: flex;
        align-items: center;
        gap: .45rem;

        &::before {
            content: counter(passo);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 1.4rem;
            height: 1.4rem;
            border-radius: 50%;
            font-size: .72rem;
            font-weight: 700;
            color: #fff;
            background: $ec-petroleo;
        }
    }
}

.eoi-vazio {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: .75rem;
    margin: 0;
    padding: 2rem 1.25rem;
    text-align: center;
    color: $ec-texto-suave;

    svg { color: $ec-salvia; }
    p { margin: 0; }
}

.eoi-barra {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: .75rem;
    margin-bottom: .75rem;
}

.eoi-resumo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem .9rem;
    font-size: .85rem;
    color: $ec-texto-suave;

    b { color: $ec-texto; }
}

.eoi-filtros {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .75rem;
}

.eoi-busca {
    position: relative;

    svg {
        position: absolute;
        left: .6rem;
        top: 50%;
        transform: translateY(-50%);
        color: $ec-texto-suave;
        pointer-events: none;
    }

    input { padding-left: 1.9rem; min-width: 220px; }
}

.eoi-meta {
    display: flex;
    flex-wrap: wrap;
    gap: .1rem 1rem;
}

.eoi-curso { margin-bottom: .75rem; }

.eoi-curso__extra {
    display: flex;
    align-items: center;
    gap: .4rem;
}

.eoi-curso__acoes {
    display: flex;
    justify-content: flex-end;
    padding: .6rem 1.25rem;
    border-bottom: 1px solid $ec-borda;
    background: rgba($ec-petroleo, .03);
}

.eoi-lista {
    margin: 0;
    padding: 0;
    list-style: none;
}

.eoi-turma {
    border-top: 1px solid $ec-borda;

    &:first-child { border-top: 0; }
}

.eoi-turma__linha {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem 1rem;
    padding: .8rem 1.25rem;
}

.eoi-turma__info {
    flex: 1 1 320px;
    min-width: 0;
}

.eoi-turma__nome {
    display: block;
    font-weight: 700;
    color: $ec-petroleo-escuro;
    overflow-wrap: anywhere;
}

.eoi-turma__meta {
    font-size: .8rem;
    color: $ec-texto-suave;

    b { color: $ec-texto; font-weight: 600; }
}

.eoi-turma__extra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem .75rem;
}

.eoi-valor {
    font-weight: 700;
    color: $ec-texto;
    white-space: nowrap;

    &--isento { color: $green; }
}

.eoi-turma__retorno {
    display: flex;
    align-items: flex-start;
    gap: .4rem;
    margin: 0 1.25rem .8rem;
    padding: .4rem .7rem;
    border-radius: .35rem;
    font-size: .8rem;
    overflow-wrap: anywhere;

    svg { flex: 0 0 auto; margin-top: .15rem; }

    &--sucesso { color: darken($green, 12%); background: rgba($green, .08); }
    &--erro { color: darken($red, 8%); background: rgba($red, .08); }
}

.eoi-dados {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem 1.5rem;
    margin: 0 0 1rem;

    dt {
        margin-bottom: .15rem;
        font-size: .72rem;
        font-weight: 600;
        letter-spacing: .03em;
        text-transform: uppercase;
        color: $ec-texto-suave;
    }

    dd { margin: 0; font-weight: 600; color: $ec-texto; }
}

// total do plano de pagamento (rodapé da tabela de parcelas)
.eoi-parcelas tfoot td {
    font-weight: 600;
    color: $ec-texto;
    background: #fafcfc;
    border-top: 2px solid $ec-borda;
}

// celular: a .ec-tabela vira cartões; o rodapé vira uma linha "Total ... valor"
@media (max-width: 767.98px) { // = media-breakpoint-down(sm)
    .eoi-parcelas tfoot { display: block; }

    .eoi-parcelas tfoot tr {
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        padding: .7rem 1rem;
        background: #fafcfc;
        border-top: 2px solid $ec-borda;

        td { display: block; width: auto; padding: 0; border: 0; background: transparent; }
    }
}

@media (max-width: 575.98px) {
    .eoi-turma__linha,
    .eoi-curso__acoes { padding-left: 1rem; padding-right: 1rem; }
    .eoi-turma__retorno { margin-left: 1rem; margin-right: 1rem; }
    .eoi-busca input { min-width: 0; width: 100%; }
    .eoi-busca { flex: 1 1 100%; }
}
</style>
